<template>
  <section class="content">
    <admin-header
      :title="'User Groups'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:entity-quick-search="search"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:csv-upload="multiSave"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    name: 'AdminUserGroup',
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    data () {
      return {
        newEntityScreen: 'Admin - User Groups',
        searchEntityScreen: 'Admin - User Group search',
        filterEventName: 'admin-user-group-filter',
        filterName: 'UserGroupFilter',
        entityName: 'user-group'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// AdminUserGroup.vue?1bfec46a